import React from 'react';
import styled from "styled-components";
import moment from "moment";
const AtText = styled.div<{
  backgroundColor: string;
  textAlign: string;
  labelPosition: string;
  fontSize: string;
  color: string;
  fontStyle: string;
  borderColor: string,
  borderWidth: string,
  borderRadius: string,
  boxShadow: string,
}>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: ${({labelPosition})=> labelPosition||'center'};
  background: ${({backgroundColor})=> backgroundColor?backgroundColor:'transparent'};
  box-shadow: ${({boxShadow})=> boxShadow};
  border-radius: ${({borderRadius})=> borderRadius};
  border: ${({borderColor, borderWidth})=> `${borderWidth}px solid ${borderColor}`};
  text-align: ${({textAlign})=> textAlign};
  .x-text-span{
    display: block;
    flex: 1;
    font-size: ${({fontSize})=> fontSize};
    color: ${({color})=> color};
    font-style: ${({fontStyle})=> fontStyle.includes('ITALIC')?'italic':'normal'};
    font-weight: ${({fontStyle})=> fontStyle.includes('BOLD')?'bold':'0'};
  }
  word-break:break-word;
`
const TTextWidget = (props:any) => {
  const {
    text,
    textType,
    dateFormat,
    maxlength,
    fontSize,
    fontStyle,
    textAlign,
    labelPosition,
    color,
    backgroundColor,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    onClick,
  } = props;
  const reText = (v:string, maxLen?:number)=>{
    if(textType === 'DATE'){
      let date = moment(parseInt(v, 10));
      let isValid = date.isValid();
      if(!isValid||!dateFormat){
        return '';
      }
      return date.format(dateFormat);
    }else if(maxLen&&(typeof v === "string")){
      return v.substring(0, maxLen) + (maxLen < v.length?'...':'');
    }else{
      return v;
    }
  }
  return (
    <AtText backgroundColor={backgroundColor}
            textAlign={textAlign}
            labelPosition={labelPosition}
            fontSize={fontSize}
            color={color}
            fontStyle={fontStyle}
            borderColor={borderColor}
            borderWidth={borderWidth}
            borderRadius={borderRadius}
            boxShadow={boxShadow}
            onClick={onClick}

    >
      <span className="x-text-span">{reText(text, maxlength)}</span>
    </AtText>
  );
};

export default TTextWidget;
